export default {"src":"/_next/static/media/designed-for-gra.bc620308.svg","height":310,"width":333,"blurWidth":0,"blurHeight":0};